import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";

import Button from "@atoms/Button";
import Icon from "@atoms/Icon";
import Link from "@atoms/Link";

import CheckoutIntl from "@pages/Checkout/CheckoutIntl";
import CheckoutKr from "@pages/Checkout/CheckoutKr";

import { URLS } from "@const/urls";

import useLanguage from "@hooks/useLanguage";

import { useCartStore } from "@store/cart";
import { useLayoutStore } from "@store/layout";

export default function Checkout() {
  const navigate = useNavigate();

  const { lang } = useLanguage();

  const { isPC } = useCheckDevice();

  const { cart } = useCartStore();
  const { showFooter } = useLayoutStore();

  useEffect(() => {
    showFooter(false);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (lang !== "jp") return;
    window.location.href = cart.checkoutUrl || URLS.HOME;
  }, [lang, cart.checkoutUrl]);

  if (lang === "jp") return null;

  return (
    <section className="pc:col-start-3 pc:w-full pc:min-w-160 pc:max-w-200 pc:place-self-center relative col-span-8 flex flex-col">
      {isPC ? (
        <section className="h-12.5 min-h-12.5 items-center justify-between p-4 px-5">
          <Link className="text-title font-features-normal leading-none" href={URLS.HOME}>
            thisisneverthat®
          </Link>
        </section>
      ) : (
        <section className="tnt-gap-x fixed top-0 left-0 mx-auto grid h-13.5 min-h-13.5 w-full grid-cols-8 items-center bg-white p-4 dark:text-white">
          <Button
            as="text"
            onClick={() => {
              const checkoutBackUrl = sessionStorage.getItem("checkoutBackUrl");
              if (checkoutBackUrl) navigate(checkoutBackUrl);
              else navigate(-1);

              sessionStorage.removeItem("checkoutBackUrl");
            }}
          >
            <Icon className="h-3.5" name="LeftArrow" />
          </Button>
          <Button
            as="text"
            className="text-base!"
            onClick={() => {
              const checkoutBackUrl = sessionStorage.getItem("checkoutBackUrl");
              if (checkoutBackUrl) navigate(checkoutBackUrl);
              else navigate(-1);

              sessionStorage.removeItem("checkoutBackUrl");
            }}
          >
            Back
          </Button>
        </section>
      )}

      <section className="pc:p-5 pc:py-5 pc:gap-10 pc:pt-5 flex flex-col gap-4 pt-20 pb-12">
        <Button
          as="text"
          className="pc:flex hidden items-center gap-2 text-base!"
          onClick={() => {
            const checkoutBackUrl = sessionStorage.getItem("checkoutBackUrl");
            if (checkoutBackUrl) navigate(checkoutBackUrl);
            else navigate(-1);

            sessionStorage.removeItem("checkoutBackUrl");
          }}
        >
          <Icon className="h-3" name="LeftArrow" />
          Back
        </Button>

        <section className="pc:pt-0 flex flex-col gap-10">{lang === "ko" ? <CheckoutKr /> : <CheckoutIntl />}</section>
      </section>
    </section>
  );
}
